var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 29,
    viewBox: "0 0 206 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.007 3H108C108.699 7.65 112.895 12 117.51 12H127.86C128 11.55 128 10.95 128 10.5C128 6.3 124.923 3 121.007 3Z",
    fill: "url(#paint0_linear_502_4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109 13V25H115.477V18.6H121.235C124.402 18.6 127.136 16.2 128 13H109Z",
    fill: "#4DB45F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87 3V25H92.7143C92.7143 25 94.1429 25 94.8571 23.4286C98.7143 14.9429 99.8571 12.4286 99.8571 12.4286H100.571V25H107V3H101.286C101.286 3 99.8571 3.15714 99.1429 4.57143C95.8571 11.8 94.1429 15.5714 94.1429 15.5714H93.4286V3H87Z",
    fill: "#4DB45F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 25V3H67.3529C67.3529 3 69.1882 3 70.1765 6.14286C72.7176 14.4714 73 15.5714 73 15.5714C73 15.5714 73.5647 13.5286 75.8235 6.14286C76.8118 3 78.6471 3 78.6471 3H85V25H78.6471V13.2143H77.9412L74.4118 25H71.5882L68.0588 13.2143H67.3529V25H61Z",
    fill: "#4DB45F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0332 3.08594H29.6566V25.768H17.0332V3.08594Z",
    fill: "#FF5F00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8332 14.427C17.8332 9.81855 19.9972 5.73088 23.3232 3.0859C20.8789 1.16236 17.7932 0.000244141 14.427 0.000244141C6.45189 0.000244141 0 6.45213 0 14.427C0 22.4018 6.45189 28.8538 14.4268 28.8538C17.793 28.8538 20.8787 27.6917 23.3232 25.768C19.9972 23.1632 17.8332 19.0355 17.8332 14.427Z",
    fill: "#EB001B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6865 14.427C46.6865 22.4018 40.2346 28.8538 32.2597 28.8538C28.8935 28.8538 25.8078 27.6917 23.3633 25.768C26.7295 23.1232 28.8535 19.0355 28.8535 14.427C28.8535 9.81855 26.6894 5.73088 23.3633 3.0859C25.8076 1.16236 28.8935 0.000244141 32.2597 0.000244141C40.2346 0.000244141 46.6867 6.49229 46.6867 14.427H46.6865Z",
    fill: "#F79E1B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M170.306 10.0394C170.265 13.1069 173.198 14.8185 175.407 15.8363C177.677 16.8805 178.44 17.5501 178.431 18.484C178.414 19.913 176.62 20.5438 174.941 20.5683C172.013 20.6112 170.31 19.8209 168.957 19.2231L167.902 23.8896C169.26 24.4812 171.775 24.9971 174.382 25.0198C180.504 25.0198 184.509 22.1633 184.53 17.7344C184.554 12.1136 176.306 11.8025 176.362 9.29013C176.382 8.52833 177.151 7.71538 178.836 7.50868C179.67 7.40427 181.972 7.32436 184.583 8.46067L185.607 3.94579C184.203 3.4626 182.399 2.99993 180.153 2.99993C174.391 2.99993 170.339 5.89531 170.306 10.0394ZM195.452 3.38882C194.334 3.38882 193.392 4.00518 192.972 4.95105L184.227 24.6882H190.344L191.562 21.508H199.036L199.743 24.6882H205.134L200.429 3.38882H195.452ZM196.307 9.14256L198.073 17.1407H193.238L196.307 9.14256ZM162.889 3.38908L158.068 24.6879H163.897L168.716 3.38855L162.889 3.38908ZM154.266 3.38855L148.199 17.886L145.745 5.55943C145.457 4.18338 144.32 3.38882 143.057 3.38882H133.139L133 4.00732C135.036 4.42498 137.349 5.09861 138.751 5.8194C139.609 6.2597 139.853 6.64459 140.135 7.69088L144.783 24.6882H150.943L160.387 3.38882L154.266 3.38855Z",
    fill: "url(#paint1_linear_502_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_4",
    x1: 107.964,
    y1: 7.5,
    x2: 128,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088CCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_4",
    x1: 166.163,
    y1: 25.4615,
    x2: 166.765,
    y2: 2.84488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment1);
export default __webpack_public_path__ + "static/media/payment1.71e953983b0506caf6d7ff6289f0a75f.svg";
export { ForwardRef as ReactComponent };